import { useGetCerfats } from "modules/cerfat/api";
import CerfatTable from "modules/cerfat/components/src/cerfatTable";
import { useState } from "react";

export const Cerfat = () => {
  const { data, fetchNextPage, fetchPreviousPage, hasNextPage } =
    useGetCerfats("");
  const [searchName, setSearchName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const totalPage = data?.pages[0].page;

  return (
    <CerfatTable
      tableData={data?.pages.flatMap((page) => page.data) || []}
      searchName={searchName}
      setSearchName={setSearchName}
      currentPage={currentPage}
      totalPage={totalPage}
      hasNextPage={hasNextPage}
      handleFetchNextPage={() => {
        fetchNextPage();
        setCurrentPage(currentPage + 1);
      }}
      handleFetchPrevPage={() => {
        fetchPreviousPage();
        setCurrentPage(currentPage - 1);
      }}
    />
  );
};
